import { Font, FontLoader } from '../thirdparty/three/imports';

export class FontLoader3D
{
    _fontLoader: FontLoader;

    constructor()
    {
        this._fontLoader = new FontLoader();
    }

    load(url: string, onLoad?: (responseFont: Font) => void, onProgress?: (event: ProgressEvent<EventTarget>) => void, onError?: (event: ErrorEvent) => void)
    {
        this._fontLoader.load(url, onLoad, onProgress, onError);
    }
}
